import { useState } from 'react';

export enum OpenBankingModalState {
  CONSENT_IFRAME = 'CONSENT_IFRAME',
  FEEDBACK = 'FEEDBACK',
  EXPLANATION = 'EXPLANATION',
  INSTRUCTION = 'INSTRUCTION',
}

type OpenBankingLocalState = 'idle' | 'loading' | 'success' | 'error';

/**
 * Hook to manage Open Banking component local state and modal state
 */
export function useOpenBankingConsentState() {
  const [openBankingLocalState, setOpenBankingLocalState] = useState<OpenBankingLocalState>('idle');
  const [openBankingModalState, setOpenBankingModalState] = useState<OpenBankingModalState | undefined>();

  const closeOpenBankingModal = () => setOpenBankingModalState(undefined);

  return {
    openBankingModalState,
    closeOpenBankingModal,
    setOpenBankingModalState,
    openBankingLocalState,
    setOpenBankingLocalState,
  };
}
